<div class="container scrollbar">
    <div class="table-responsive mt-5">
        <div class="d-flex align-items-center mb-2" style="justify-content: space-between; margin: 0.5rem;">
            <h4 class="title16 text-uppercase" translate>lblShareboxLog</h4>
            <div class="d-flex">
                <div class="form-check pl-0 mr-2" *ngIf="isKeyPickupWithoutPayment">
                    <label class="form-check-label" for="isKeyPickupWithoutPayment" translate>{{'lblKeyPickupInShareboxWithoutPayment' | translate}}: {{'lblYes' | translate}}</label>
                </div>
                <button class="btn btn-primary customize-btn mr-2" *ngIf="!isKeyPickupWithoutPayment" [disabled]="!isKeyPickupWithoutPayment ? isLatestKeyPickUp : isKeyPickupWithoutPayment" 
                    (click)="openParkingDetailsPopup($event, viewParkingDetailForm)" aria-label="Center Align">
                    <span translate>lblKeyPickupInShareboxWithoutPayment</span>
                </button>
                <button class="btn btn-primary customize-btn mr-2" [disabled]="isLatestKeyPickUp"
                    (click)="onReserveLocker(false)" aria-label="Center Align">
                    <span translate>lblReserveSharebox</span>
                </button>
                <button class="btn btn-primary customize-btn mr-2" [disabled]="isLatestKeyPickUp"
                    (click)="onReserveLocker(true)" aria-label="Center Align" hidden>
                    <span translate>lblReserveSharebox&SendSMS</span>
                </button>
            </div>            
        </div>

        <table class="tablest1">
            <thead>
                <tr>
                    <th style="width: 19%;" scope="col" translate>lblEvent</th>
                    <th style="width: 15%;" scope="col" translate>lblEventDateTime</th>
                    <th style="width: 10%;" scope="col" translate>lblLockerNo</th>
                    <th style="width: 15%;" scope="col" translate>lblLocationName</th>
                    <th style="width: 12%; cursor: pointer;" scope="col" translate>lblApplication</th>
                    <th style="width: 15%; cursor: pointer;" scope="col" translate>lblUser</th>
                    <th style="width: 75px;" class="text-center" scope="col" translate>lblAction</th>
                </tr>
            </thead>
            <tbody>
                <ng-container *ngIf="shareBoxLogData?.length > 0; else noData">
                    <tr *ngFor="let log of shareBoxLogData; let i = index">
                        <td>
                            <ngb-highlight [result]="log.eventName" [term]="searchTerm"></ngb-highlight>
                        </td>
                        <td>
                            <ngb-highlight [result]="log.eventDateTime | date:'short'"
                                [term]="searchTerm"></ngb-highlight>
                        </td>
                        <td>
                            <ngb-highlight [result]="log.lockerNo " [term]="searchTerm"></ngb-highlight>
                        </td>
                        <td>
                            <ngb-highlight [result]="log.locationName " [term]="searchTerm"></ngb-highlight>
                        </td>
                        <td>
                            <ngb-highlight [result]="log.applicationName" [term]="searchTerm"></ngb-highlight>
                        </td>
                        <td>
                            <ngb-highlight [result]="log.displayName" [term]="searchTerm"></ngb-highlight>
                        </td>
                        <td class="text-center" style="display: flex;justify-content: center;">
                            <div class="d-flex" style="gap: 1rem;">
                                <button type="button" class="btn btn-primary customize-btn ml-2"
                                    *ngIf="log.eventName?.includes('Key Drop') || log.eventName?.includes('Customer Key Drop')"
                                    [disabled]="!log.isLatest" (click)="onOpenLocker(autoKeyDetailId)"
                                    title="Open Locker" translate>
                                    lblOpenLocker
                                </button>
                            </div>
                        </td>
                    </tr>
                </ng-container>
            </tbody>
        </table>

        <ng-template #noData>
            <tr>
                <td colspan="7" class="no-record" translate>lblNoRecordsFound</td>
            </tr>
        </ng-template>
    </div>
</div>

<div class="p-3 bg-light pp-footer-top-brdr">
    <div class="d-flex flex-sm-row flex-column justify-content-end">
        <a (click)="OnClose('modal')" type="reset" class="btn btn-secondary btn-lg" translate>
            <em class="far fa-times-circle font16 align-top mr-2"></em> lblCancel</a>
    </div>
</div>
<ng-template #viewParkingDetailForm let-modal>
    <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title" translate>lblParkingDetailsSharebox
        </h4>
        <button type="button" class="close" aria-label="Close" (click)="OnClose(modal)"><span
                aria-hidden="true">×</span></button>
    </div>
    <div class="modal-body table-responsive">
        <div class="col-6 col-lg-6">
            <div class="af-form-group">
                <label translate>lblParkingNote</label>
                <div class="lbl-nfo">
                    <input type="text" class="form-control"
                        [disabled]="editAppointmentService.appointmentDetails.isFromArchive"
                        [(ngModel)]="parkingDetails" maxlength="200" />
                </div>
            </div>
        </div>
        
    </div>
    <div class="modal-footer">
        <button class="btn btn-primary customize-btn mr-2" [disabled]="isLatestKeyPickUp"
            (click)="modal.dismiss({success : true})" aria-label="Center Align">
            <span translate>lblReserveSharebox&SendSMS</span>
        </button>
        <button type="button" class="btn btn-secondary customize-btn mr-2"  (click)="OnClose(modal)">
            <span translate>lblCancel</span>
        </button>
    </div>
</ng-template>
